import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import backgroundImage from '../../../assets/background.jpg';
import { notifyExternalRegistrationResult } from '../utils/external-session-notify';
import FailedSVG from './components/FailedSvg';

export default function PaymentFailedScreen() {
  const navigate = useNavigate();

  useEffect(() => {
    notifyExternalRegistrationResult('success', {
      paymentStatus: 'failed'
    });
  }, []);

  return (
    <div
      className="flex h-full w-full flex-col items-center justify-center px-4"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        minHeight: '100vh'
      }}
    >
      <img
        src={require('../../../assets/logos/aye-logo.png')}
        alt="Aye Logo"
        className="h-8 w-16"
      />
      <div className="mt-4 flex flex-col items-center justify-center">
        <FailedSVG />
        <h1 className="mt-4 text-center text-2xl font-semibold text-red-600">
          Payment Failed
        </h1>
        <p className="mt-2 text-center text-lg font-medium text-green-600">
          But your registration was successful!
        </p>
      </div>

      <div className="mt-6 max-w-md px-4 text-center text-[0.95rem] text-gray-800">
        <p>
          You can log in to your account and add a payment method anytime at{' '}
          <a
            className="text-[#237ABE] underline"
            href={`${window.location.origin}/login`}
            target="_self"
            rel="noopener noreferrer"
          >
            {window.location.hostname}/login
          </a>{' '}
          to start using AyeFace.
        </p>
      </div>

      <div className="mt-8 flex gap-4">
        <button
          type="button"
          className="w-36 rounded-2xl bg-[#5CB891] px-8 py-2 font-semibold text-white"
          onClick={() => navigate('/login')}
        >
          Log In
        </button>
      </div>
    </div>
  );
}
